import { productNames } from '../../products';
import BankTransferInstructions from '../../components/BankTransferInstructions';
import './styles/AwaitingPayment.scss';

export type PendingBankTransfer = {
    orderId: string;
    product: number;
    amount: number;
    variableSymbol: string;
    iban: string;
    accountDisplay: string;
    qrCode?: string | null;
    installmentId: string;
    invoiceId?: string | null;
};

// Shown in the course to a buyer whose bank transfer hasn't arrived yet — their access is
// granted once an admin confirms the incoming payment.
export default function AwaitingPayment({ data }: { data: PendingBankTransfer }) {
    return (
        <div className="awaitingPayment">
            <div className="apCard">
                <div className="apIcon">⏳</div>
                <h1>Čekáme na tvou platbu</h1>
                <p>
                    Objednávku <b>{productNames[data.product] ?? "Produkt"}</b> ti aktivujeme, jakmile dorazí platba
                    převodem — obvykle to trvá 1–2 pracovní dny. Pokyny k platbě máš i v e-mailu.
                </p>
                <BankTransferInstructions
                    info={{
                        amount: data.amount,
                        variableSymbol: data.variableSymbol,
                        iban: data.iban,
                        accountDisplay: data.accountDisplay,
                        qrCode: data.qrCode,
                        invoiceId: data.invoiceId,
                    }}
                    canDownload={true}
                />
            </div>
        </div>
    );
}
